import React, {FC} from 'react';

const Koutu: FC = () => {
  return <img id="KoutuLogo" alt="抠图" width="160" height="160" src="https://i.tosoiot.com/static/images/koutu.png" />;
};

export default Koutu;
